import React from "react";
import { useTranslation } from "react-i18next";

export const TitleBar: React.FC = () => {
  const { t } = useTranslation();
  // Only render if we're in a PWA with window controls overlay
  if (
    window.navigator.userAgent.includes("Chrome") &&
    window.matchMedia("(display-mode: window-controls-overlay)").matches
  ) {
    return (
      <div className="titlebar-area">
        <h1>{t("common.appName")}</h1>
      </div>
    );
  }

  // Return null if not in PWA mode or window controls overlay is not active
  return null;
};

export default TitleBar;
